module.exports = __webpack_public_path__ + "static/media/users.a0620177.png";